import { VirtualAtonTargetInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';
import { useLengthUnits } from '../../Units/useLengthUnits';
import {
  InfoTooltipFields,
  type TooltipFieldDefinition,
} from './InfoTooltipFields';

interface VirtualAtonInfoTooltipProps {
  virtualAtonInfo: VirtualAtonTargetInfo;
}

export const VirtualAtonInfoTooltip = ({
  virtualAtonInfo,
}: VirtualAtonInfoTooltipProps) => {
  const { settings } = useSettings();
  const ribbonSettings = settings['ribbonPlugin.settings'];
  const { convertLengthString } = useLengthUnits();

  const fields: TooltipFieldDefinition[] = [
    {
      key: 'assignedMode',
      label: 'Assigned mode',
      value: virtualAtonInfo.assignedMode,
      visible: ribbonSettings?.show_virtual_aton_assigned_mode,
    },
    {
      key: 'atonType',
      label: 'Virtual AtoN type',
      value: virtualAtonInfo.atonType,
      visible: ribbonSettings?.show_virtual_aton_type,
    },
    {
      key: 'virtualAtonTargetType',
      label: 'Target type',
      value: virtualAtonInfo.targetType,
      visible: ribbonSettings?.show_virtual_aton_target_type,
    },
    {
      key: 'country',
      label: 'Country',
      value: virtualAtonInfo.country,
      visible: ribbonSettings?.show_virtual_aton_country,
    },
    {
      key: 'latitude',
      label: 'Latitude',
      value: virtualAtonInfo.latitude,
      visible: ribbonSettings?.show_virtual_aton_latitude,
    },
    {
      key: 'longitude',
      label: 'Longitude',
      value: virtualAtonInfo.longitude,
      visible: ribbonSettings?.show_virtual_aton_longitude,
    },
    {
      key: 'length',
      label: 'Length',
      value: virtualAtonInfo.length
        ? convertLengthString(virtualAtonInfo.length)
        : undefined,
      visible: ribbonSettings?.show_virtual_aton_length,
    },
    {
      key: 'mmsi',
      label: 'MMSI',
      value: virtualAtonInfo.mmsi,
      visible: ribbonSettings?.show_virtual_aton_mmsi,
    },
    {
      key: 'name',
      label: 'Name',
      value: virtualAtonInfo.name,
      visible: ribbonSettings?.show_virtual_aton_name,
    },
    {
      key: 'offPosition',
      label: 'Off position',
      value: virtualAtonInfo.offPosition,
      visible: ribbonSettings?.show_virtual_aton_off_position,
    },
    {
      key: 'state',
      label: 'State',
      value: virtualAtonInfo.state,
      visible: ribbonSettings?.show_virtual_aton_state,
    },
    {
      key: 'status',
      label: 'Status',
      value: virtualAtonInfo.status,
      visible: ribbonSettings?.show_virtual_aton_status,
    },
    {
      key: 'width',
      label: 'Width',
      value: virtualAtonInfo.width
        ? convertLengthString(virtualAtonInfo.width)
        : undefined,
      visible: ribbonSettings?.show_virtual_aton_width,
    },
  ];

  return <InfoTooltipFields fields={fields} fallback="Unknown" />;
};
